import { Select } from '@/components/ui/select';
import { useBusinessSectors, useBusinessTypes } from '@/hooks/useListHelper';

interface BusinessSelectorProps {
  sectorId?: string;
  sectorName?: string;
  typeId?: string;
  typeName?: string;
  onSectorChange?: (id: string, name: string) => void;
  onTypeChange?: (id: string, name: string) => void;
  errors?: {
    sectorId?: string;
    typeId?: string;
  };
  required?: boolean;
  // Layout: '2col' (default) | 'stack'
  layout?: '2col' | 'stack';
}

export default function BusinessSelector({ sectorId, typeId, onSectorChange, onTypeChange, errors, required = false, layout = '2col' }: BusinessSelectorProps) {
  const { data: sectors = [], isLoading: loadingSectors } = useBusinessSectors();

  // Lọc types theo sector đã chọn
  const { data: allTypes = [], isLoading: loadingTypes } = useBusinessTypes();
  const filteredTypes = sectorId ? allTypes.filter((t) => t.businessSectorId === sectorId) : allTypes;

  const sectorOpts = sectors.map((s) => ({ value: s.id, label: s.name }));
  const typeOpts = filteredTypes.map((t) => ({ value: t.id, label: t.name }));

  const req = required ? ' *' : '';

  const content = (
    <>
      {/* Business Sector */}
      <Select
        label={`Ngành kinh doanh${req}`}
        placeholder={loadingSectors ? 'Đang tải...' : '-- Chọn ngành --'}
        options={sectorOpts}
        value={sectorId ?? ''}
        onChange={(e) => {
          const id = e.target.value;
          const name = sectors.find((s) => s.id === id)?.name ?? '';
          onSectorChange?.(id, name);
          // Reset type khi đổi sector
          onTypeChange?.('', '');
        }}
        error={errors?.sectorId}
        disabled={loadingSectors}
      />

      {/* Business Type */}
      <Select
        label={`Loại hình kinh doanh${req}`}
        placeholder={!sectorId ? 'Chọn ngành trước' : loadingTypes ? 'Đang tải...' : filteredTypes.length === 0 ? 'Không có loại hình' : '-- Chọn loại hình --'}
        options={typeOpts}
        value={typeId ?? ''}
        onChange={(e) => {
          const id = e.target.value;
          const name = filteredTypes.find((t) => t.id === id)?.name ?? '';
          onTypeChange?.(id, name);
        }}
        error={errors?.typeId}
        disabled={!sectorId || loadingTypes}
      />
    </>
  );

  if (layout === 'stack') {
    return <div className="space-y-4">{content}</div>;
  }

  return <div className="grid grid-cols-2 gap-4">{content}</div>;
}
